import { ControlList } from "@harea/component";
import { useNavigate, useParams } from "react-router-dom";
import { useTimeOffMissingControlForm } from "../hooks/useTimeOffMissingControlForm";
import { useProjectTimeOffNavigateBack } from "views/create/hooks/useProjectTimeOffNavigateBack";
import { useTimeOffInvalidateQuery } from "hooks/useTimeOffInvalidateQuery";
import { useCountSoldMutation } from "hooks/useCountSoldMutation";
import { useQueryClient } from "react-query";

const ProjectAppointmentCreateMissingContainer = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const control = useTimeOffMissingControlForm(id ? parseInt(id) : undefined);
    const invalidateTimeOffsQuery = useTimeOffInvalidateQuery()
    const navigateBack = useProjectTimeOffNavigateBack()
    const countSoldMutation = useCountSoldMutation()
    const queryClient = useQueryClient()

    const handleSubmited = (value) => {
        countSoldMutation.mutate(value?.id)
        invalidateTimeOffsQuery()
        queryClient.invalidateQueries('App.bo.ContractManagerQuery')
        navigateBack();
    };

    return (
        <ControlList
            {...control}
            id="timeoff-edit-missing-form"
            onSubmited={handleSubmited}
            onCancel={() => navigate(-1)}
        />
    );
};

export default ProjectAppointmentCreateMissingContainer;

const i18n = [
    "Harea.Project.DayOff.Create.Notification.Message",
    "Harea.Project.DayOff.Create.Dialog.Title",
];
